import React, { Component } from "react";

class Footer extends Component {
  constructor() {
    super();
    let jetzt = new Date();
    let Jahr = jetzt.getYear();
    if (Jahr < 999) Jahr += 1900;

    this.state = {
      date: Jahr
    };
  }

  render() {
    return (
      <footer>
        <div className="footer-content">
          <ul className="footer-menu">
            <li>
              <a href="#main">Start</a>
            </li>
            <li>
              <a href="#gallery">Gallerie</a>
            </li>
            <li>
              <a href="#about-us">Impressum</a>
            </li>
            <li>
              <a href="#contact">Kontakt</a>
            </li>
          </ul>

          <p className="footer-text">
            &copy;
            {this.state.date}
            &nbsp;Tambour Korps
            <br />
            Design by <a href="http://www.styleshout.com/">Styleshout</a>
            <br />
            Angepasst und Nachgebaut in React von
            <a href="https://merlinscheurer.de.tl/"> MerlinS.</a>
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js